import { render, staticRenderFns } from "./PaySucceed.vue?vue&type=template&id=023b6f56&scoped=true&"
import script from "./PaySucceed.vue?vue&type=script&lang=js&"
export * from "./PaySucceed.vue?vue&type=script&lang=js&"
import style0 from "./PaySucceed.vue?vue&type=style&index=0&id=023b6f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b6f56",
  null
  
)

export default component.exports